var _circle, _g, _path, _g2, _path2, _ellipse, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconePuericultura = function SvgIconePuericultura(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_d_14652_31263)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "#DBF6F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82227 20.9111C9.82227 19.7329 10.7774 18.7778 11.9556 18.7778H24.0445C25.2227 18.7778 26.1778 19.7329 26.1778 20.9111C26.1778 22.0893 25.2227 23.0444 24.0445 23.0444H20.4889V26.6C18.9467 27.4813 17.0534 27.4813 15.5112 26.6V23.0444H11.9556C10.7774 23.0444 9.82227 22.0893 9.82227 20.9111Z",
    fill: "#1E8B7F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14652_31263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7554 14.1555C24.7554 17.8865 21.7309 20.9111 17.9999 20.9111C14.2689 20.9111 11.2443 17.8865 11.2443 14.1555C11.2443 10.4245 14.2689 7.39996 17.9999 7.39996C21.7309 7.39996 24.7554 10.4245 24.7554 14.1555Z",
    fill: "#50BBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.511 9.88885C15.511 11.2634 14.3967 12.3777 13.0221 12.3777C11.6475 12.3777 10.5332 11.2634 10.5332 9.88885C10.5332 8.51428 11.6475 7.39996 13.0221 7.39996C14.3967 7.39996 15.511 8.51428 15.511 9.88885Z",
    fill: "#50BBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4665 9.88885C25.4665 11.2634 24.3522 12.3777 22.9776 12.3777C21.6031 12.3777 20.4888 11.2634 20.4888 9.88885C20.4888 8.51428 21.6031 7.39996 22.9776 7.39996C24.3522 7.39996 25.4665 8.51428 25.4665 9.88885Z",
    fill: "#50BBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0443 24.1111C24.0443 25.8784 22.7708 27.3111 21.1999 27.3111C19.6289 27.3111 18.3554 25.8784 18.3554 24.1111C18.3554 22.3438 19.6289 20.9111 21.1999 20.9111C22.7708 20.9111 24.0443 22.3438 24.0443 24.1111Z",
    fill: "#50BBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6443 24.1111C17.6443 25.8784 16.3708 27.3111 14.7999 27.3111C13.2289 27.3111 11.9554 25.8784 11.9554 24.1111C11.9554 22.3438 13.2289 20.9111 14.7999 20.9111C16.3708 20.9111 17.6443 22.3438 17.6443 24.1111Z",
    fill: "#50BBAF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1064 11.2625C24.5027 10.9364 24.7555 10.4422 24.7555 9.88892C24.7555 8.90708 23.9595 8.11114 22.9777 8.11114C22.5223 8.11114 22.1068 8.28241 21.7923 8.56405C22.7845 9.2383 23.5878 10.1697 24.1064 11.2625ZM14.2076 8.56404C13.8931 8.28239 13.4776 8.11111 13.0222 8.11111C12.0403 8.11111 11.2444 8.90705 11.2444 9.88889C11.2444 10.4422 11.4971 10.9364 11.8935 11.2625C12.4121 10.1697 13.2154 9.23829 14.2076 8.56404Z",
    fill: "#1E8B7F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 16.6446,
    rx: 3.91111,
    ry: 2.84444,
    fill: "#9BE1D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.311 13.4444C20.6055 13.4444 20.8443 13.126 20.8443 12.7333C20.8443 12.3405 20.6055 12.0221 20.311 12.0221C20.0164 12.0221 19.7776 12.3405 19.7776 12.7333C19.7776 13.126 20.0164 13.4444 20.311 13.4444ZM15.6889 13.4444C15.9834 13.4444 16.2222 13.1261 16.2222 12.7333C16.2222 12.3406 15.9834 12.0222 15.6889 12.0222C15.3943 12.0222 15.1555 12.3406 15.1555 12.7333C15.1555 13.1261 15.3943 13.4444 15.6889 13.4444Z",
    fill: "#1E8B7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2276 15.9333C19.2276 16.3261 18.75 16.6445 18.1609 16.6445C17.5718 16.6445 17.0943 16.3261 17.0943 15.9333C17.0943 15.5406 17.5718 15.2222 18.1609 15.2222C18.75 15.2222 19.2276 15.5406 19.2276 15.9333Z",
    fill: "#1E8B7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9831 17.2716V16.2889H18.3387V17.2716C18.3387 17.4736 18.4528 17.6583 18.6335 17.7487C18.7837 17.8237 18.9604 17.8237 19.1105 17.7487L19.1856 17.7111C19.266 17.6709 19.3288 17.6056 19.3663 17.5275C19.4087 17.439 19.485 17.3556 19.5831 17.3556C19.6813 17.3556 19.763 17.4363 19.7401 17.5317C19.6888 17.7449 19.546 17.9285 19.3446 18.0291L19.2696 18.0667C19.0193 18.1918 18.7248 18.1918 18.4745 18.0667C18.1734 17.9161 17.9831 17.6083 17.9831 17.2716Z",
    fill: "#1E8B7F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3387 17.2716V16.2889H17.9831V17.2716C17.9831 17.4736 17.869 17.6583 17.6883 17.7487C17.5382 17.8237 17.3614 17.8237 17.2113 17.7487L17.1362 17.7111C17.0558 17.6709 16.9931 17.6056 16.9556 17.5275C16.9131 17.439 16.8369 17.3556 16.7387 17.3556C16.6405 17.3556 16.5588 17.4363 16.5818 17.5317C16.6331 17.7449 16.7759 17.9285 16.9772 18.0291L17.0523 18.0667C17.3025 18.1918 17.5971 18.1918 17.8473 18.0667C18.1485 17.9161 18.3387 17.6083 18.3387 17.2716Z",
    fill: "#1E8B7F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14652_31263",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.733333 0 0 0 0 0.686275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31263"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31263",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14652_31263",
    x: 9.5332,
    y: 6.39996,
    width: 16.9333,
    height: 21.9111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.470588 0 0 0 0 0.427451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31263"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31263",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconePuericultura, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icone-puericultura.20bee1ef.svg";
export { ForwardRef as ReactComponent };